<style lang="sass">
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables
@import sass/zone/zone
@import sass/backgrounds/backgrounds
</style>

<template>
    <section
        :id="id"
        :data-label="dataLabel"
        class="g_section"
        :class="classNames">
        <div
            v-if="backgroundImage && (hasParallax() ? parallaxLoaded : true)"
            class="g_bg"
            :class="[classNamesBg, {'g_parallax': hasParallax()}]"
            v-img-src="backgroundImage"
            :style="{
                backgroundPosition: backgroundImage.position || null,
                backgroundSize: backgroundImage.size || null,
                backgroundColor: backgroundImage.color || null,
                backgroundAttachment: backgroundImage.attachment || null
            }"
            v-parallax="parallax.speed"></div>
        <slot name="before"></slot>
        <div
            class="g_restrict"
            :class="[classNamesRestrict]"
            v-if="restrict && $slots.default">
            <div :class="[{'g_content': !classNamesContent}, classNamesContent]">
                <div class="g_text">
                    <slot />
                    <slot name="insideRestrict" />
                </div>
            </div>
        </div>
        <slot name="after" />
    </section>
</template>
<script>
import Vue from 'vue'
import { capitalize } from '../../assets/js/utils'
import * as constants from './constants'
import ZoneTracking from '../../assets/js/mixins/ZoneTracking'

export default {
    name: 'Zone',
    mixins: [ZoneTracking],
    props: {
        id: String,
        dataLabel: String,
        contrast: {
            type: String,
            validator (value) {
                return !!~constants.CONTRASTS.indexOf(value)
            }
        },
        autoHeight: Boolean,
        align: {
            type: String,
            validator (value) {
                return !!~constants.ALIGNMENTS.indexOf(value)
            }
        },
        position: {
            type: String,
            validator (value) {
                return !!~constants.POSITIONS.indexOf(value)
            }
        },
        mobilePosition: {
            type: String,
            validator (value) {
                return !!~constants.POSITIONS_MOBILE.indexOf(value)
            }
        },
        classNamesBg: {},
        classNamesRestrict: {},
        classNamesContent: {},
        backgroundImage: Object,
        restrict: {
            type: Boolean,
            default: true
        },
        parallax: {
            type: Object,
            default: () => {
                return {
                    speed: 0,
                    height: null
                }
            }
        }
    },
    data () {
        return {
            parallaxLoaded: false
        }
    },
    computed: {
        classNames () {
            const classNames = []
            if (this.contrast) {
                classNames.push('g_' + this.contrast)
            }
            if (this.autoHeight) {
                classNames.push(constants.AUTO_HEIGHT_CLASS)
            }
            if (this.align) {
                classNames.push('g_' + this.align)
            }
            if (this.position) {
                classNames.push('g_' + this.position)
            }
            if (this.mobilePosition) {
                classNames.push('g_mobile' + capitalize(this.mobilePosition))
            }
            return classNames
        }
    },
    created () {
        if (this.hasParallax()) {
            import(/* webpackChunkName: "VueParallaxJs" */ '../../assets/js/directives/vue-parallax-js').then(VueParallaxJs => {
                Vue.use(VueParallaxJs, {
                    minWidth: 767 // min width to activate parallax
                })
                this.parallaxLoaded = true
            })
        } else if (!this.$parallaxjs) {
            Vue.directive('parallax', {})
        }
    },
    mounted () {
        this.parallaxRules()
    },
    methods: {
        hasParallax () {
            return !this.$breakpoint.isS && this.parallax.speed !== 0 && this.parallax.height
        },
        parallaxRules () {
            // No parallax
            if (!this.hasParallax()) {
                return
            }

            let css = `
            .g #${this.id} .g_bg.g_parallax {
                height: ${this.parallax.height}px
            }`
            document.styleSheets[0].insertRule(css, 0)
            css = `
            @media screen and (min-width: 1920px) {
                .g #${this.id} .g_bg.g_parallax {
                    height: ${this.parallax.height / 1920 * 100}vw
                }
            }`
            document.styleSheets[0].insertRule(css, 1)
        }
    }
}

// TODO Doc
//    .g_section
//        &.g_light
//        &.g_dark
//        &.g_right
//        &.g_left
// .g_section .g_sectionRestrict .g_sectionSmall
// TODO require sass only if needed
</script>
